import { render } from "./FacultyListDataTable.vue?vue&type=template&id=7c89fb96&scoped=true"
import script from "./FacultyListDataTable.vue?vue&type=script&lang=js"
export * from "./FacultyListDataTable.vue?vue&type=script&lang=js"

import "./FacultyListDataTable.vue?vue&type=style&index=0&id=7c89fb96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c89fb96"]])

export default __exports__